<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="editForm" :rules="rules" ref="editForm">

            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="机构" required prop="institutionCode">
                  <el-select v-model="editForm.institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%">
                    <el-option
                        v-for="item in arr_ins"
                        :key="item.institutionCode"
                        :label="item.userName"
                        :value="item.institutionCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="名称" required prop="name">
                  <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="护理等级" required prop="nursingLevelCode">
                  <el-select v-model="editForm.nursingLevelCode" @change="nursingChange" placeholder="请选择护理等级" style="width:100%">
                    <el-option
                        v-for="item in nursingLevelList"
                        :key="item.nursingLevelCode"
                        :label="item.name"
                        :value="item.nursingLevelCode">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.priceMonth}}元/月</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="房间类型" required prop="roomTypeCode">
                  <el-select v-model="editForm.roomTypeCode" @change="roomTypeChange" placeholder="请选择房间类型" style="width:100%">
                    <el-option
                        v-for="item in roomTypeList"
                        :key="item.roomTypeCode"
                        :label="item.name"
                        :value="item.roomTypeCode">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.priceMonth}}元/月</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>

            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="建议价格(元/月)">
                  <el-input type="number" ref="univalence" v-model="advisePrice" :disabled="true"  placeholder="建议单价"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="实际价格(元/月)" required prop="univalence">
                  <el-input type="number" ref="univalence" v-model="editForm.univalence" placeholder="请输入单价"></el-input>
                </el-form-item>
              </el-col>
            </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Edit',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      nursingLevelPrice:0,
      roomTypePrice:0,
      advisePrice:"",

      nursingLevelList:[],
      roomTypeList:[],
      institutionArgList:[],


      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',
        name:'',
        univalence:'',
        nursingLevelCode:'',
        roomTypeCode:'',
        status:'',
        checkinSetmealCode:'',
      },

      rules:{
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        univalence:[
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
        nursingLevelCode:[
          { required: true, message: '请选择护理等级', trigger: 'blur' },
        ],
        roomTypeCode:[
          { required: true, message: '请输入房间类型', trigger: 'blur' },
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],

      }


    }
  },

  methods: {
    init(row){

      this.editForm.name=row.name
      this.editForm.status = row.status
      this.editForm.univalence=row.univalence
      this.editForm.roomTypeCode=row.roomTypeCode
      this.editForm.checkinSetmealCode=row.checkinSetmealCode
      this.editForm.nursingLevelCode=row.nursingLevelCode
      this.editForm.institutionCode = row.institutionCode;

      this.nursingLevelPrice = row.nursingLevelPrice;
      this.roomTypePrice = row.roomTypePrice;

      this.getNursingList();
      this.getRoomTypeList();

    },
    closeSelf() {
      this.$emit("closeEdit");
    },

    insChange(val){
      this.institutionCode = val;


      this.nursingLevelList = [];
      this.roomTypeList= [];

      this.editForm.roomTypeCode = '';
      this.editForm.nursingLevelCode = '';

      this.getNursingList();
      this.getRoomTypeList();
    },


    getNursingList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingLevel/InsList",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          institutionCode:this.editForm.institutionCode,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.nursingLevelList=response.data.data

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    getRoomTypeList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"RoomType/InsList",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          institutionCode:this.editForm.institutionCode,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.roomTypeList=response.data.data

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


    nursingChange(){
      this.editForm.univalence = "";
      this.nursingLevelList.forEach(element => {
        if(this.editForm.nursingLevelCode==element.nursingLevelCode){
          this.nursingLevelPrice = element.priceMonth;
        }
      });
      if(this.editForm.roomTypeCode!=""){
        this.advisePrice = 0;
        this.advisePrice=this.nursingLevelPrice+this.roomTypePrice;
      }
    },
    roomTypeChange(){
      this.editForm.univalence = "";
      this.roomTypeList.forEach(element => {
        if(this.editForm.roomTypeCode==element.roomTypeCode){
          this.roomTypePrice = element.priceMonth;
        }
      });
      if(this.editForm.nursingLevelCode!=""){
        this.advisePrice = 0;
        this.advisePrice=this.nursingLevelPrice+this.roomTypePrice;
      }
    },


    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){
      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/GovEdit",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>


</style>
